export default __webpack_public_path__ + "static/media/73.e20ad805.jpeg";